<section class="no-election-state" aria-label="Nenhuma eleição ativa no momento">
  <div class="no-election-hero">
    <ngx-particles
      class="hero-particles"
      [id]="particlesId"
      [options]="particlesOptions"
      [particlesInit]="particlesInit">
    </ngx-particles>

    <div class="hero-copy">
      <span class="hero-kicker">Portal de votação da CIPA</span>
      <h1 class="hero-title">No momento não existem eleições ativas para participação</h1>
      <p class="hero-description">
        Quando uma nova votação for aberta para o seu estabelecimento, ela ficará disponível aqui com acesso simples,
        instruções claras e acompanhamento do processo.
      </p>
    </div>

    <aside class="hero-summary">
      <span class="summary-label">Situação atual</span>
      <strong class="summary-title">Nenhuma eleição disponível</strong>
      <p class="summary-text">
        Você pode retornar mais tarde para verificar novas votações liberadas para o seu perfil.
      </p>
    </aside>
  </div>

  <div class="info-grid">
    <article class="info-card">
      <span class="info-card-icon"><i class="fa fa-clock" aria-hidden="true"></i></span>
      <h2>Abertura de novas votações</h2>
      <p>As eleições aparecem automaticamente nesta área assim que o período de participação for iniciado.</p>
    </article>

    <article class="info-card">
      <span class="info-card-icon"><i class="fa fa-shield-alt" aria-hidden="true"></i></span>
      <h2>Processo seguro e orientado</h2>
      <p>Quando disponível, o fluxo continuará simples, objetivo e preparado para todos os colaboradores aptos.</p>
    </article>

    <article class="info-card">
      <span class="info-card-icon"><i class="fa fa-bell" aria-hidden="true"></i></span>
      <h2>Consulte novamente em breve</h2>
      <p>Se a sua unidade estiver em fase preparatória, a liberação ocorrerá conforme o cronograma oficial da eleição.</p>
    </article>
  </div>
</section>
